import * as React from 'react';

import cx from 'classnames';

import { translate } from '~l10n/client';
import { AlertMessage } from '~shared/components/AlertMessage';
import { SmallButton } from '~shared/components/buttons';
import { Divider } from '~shared/components/Divider';
import { Link } from '~shared/components/Link';
import TextInput from '~shared/components/TextInput';

interface Props {
  error: string;
  isDisabled: boolean;
  importBySocNumber: ImportBySocNumber;
}

export type ImportBySocNumber = (socNumber: string) => void;

const IMPORT_LEARN_MORE_ARTICLE =
  'https://help.socrative.com/en/articles/2155335-import-a-quiz';

export function ImportQuizBySoc({
  isDisabled,
  importBySocNumber,
  error,
}: Props) {
  const [socNumber, setSocNumber] = React.useState('');
  const isError = error != null;
  const socNumberInputClass = cx('w-26', { 'border-red-800': isError });

  return (
    <div className="flex flex-col gap-4">
      <div>
        <span
          className="font-default font-400 text-base text-blue-900 leading-8"
          id="soc-code-description"
        >
          {translate(
            'Import a quiz from another user or from an excel template.'
          )}{' '}
          <Link
            href={IMPORT_LEARN_MORE_ARTICLE}
            target="_blank"
            rel="noreferrer"
          >
            {translate('Learn More')}
          </Link>
        </span>
        <div className="my-5">
          <Divider />
        </div>
      </div>
      <label
        id="soc-code-label"
        className="m-0 pr-6 text-base text-blue-900 leading-8 font-400"
        htmlFor="soc-number"
      >
        {translate('SOC Code')}
      </label>
      <div className="flex gap-2">
        <div className="flex-grow">
          <TextInput
            value={socNumber}
            id="soc-number"
            withBorder
            className={socNumberInputClass}
            placeholder="SOC-XXXXX"
            aria-labelledby="soc-code-label"
            aria-describedby="soc-code-description"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setSocNumber(event.target.value)
            }
          />

          {isError ? (
            <AlertMessage showIcon tone="critical">
              {error}
            </AlertMessage>
          ) : null}
        </div>

        <div className="flex-shrink">
          <SmallButton
            onClick={() => importBySocNumber(socNumber)}
            isDisabled={isDisabled}
          >
            {translate('Import Quiz')}
          </SmallButton>
        </div>
      </div>
    </div>
  );
}
